import {useContext, useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {sessionApi} from 'api';
import {DataWrapper, TextChatMessageList} from 'components';
import {ACTIVITY_NAME_TRANSLATE} from 'constants/session';
import {UserSessionContext} from 'context';
import {useApiData, useUserSession} from 'hooks';
import {SessionActivityName} from 'interfaces';
import {UserParticipantRole} from 'types';
import {sessionUtils} from 'utils';

import {SidebarView} from '../../types';
import {SidebarContent} from '../SidebarContent';

export const AvatarHistorySidebar: React.FC = () => {
    const {t} = useTranslation();
    const {localParticipant, sessionId, participants} = useUserSession();
    const {sidebarView} = useContext(UserSessionContext);

    // avatar activity is not available because it already ended.
    // fetch avatar activity data instead
    const {send: fetchActivityData, data, loading, error} = useApiData(sessionApi.getActivityData);
    const messages = useMemo(() => sessionUtils.getTextChatActivityMessages(data?.activities?.[0]?.data?.threads), [data]);

    useEffect(() => {
        if (sidebarView === SidebarView.AvatarHistory) {
            fetchActivityData(sessionId, SessionActivityName.Avatar);
        }
    }, [sidebarView, sessionId, fetchActivityData]);

    return (
        <SidebarContent
            view={SidebarView.AvatarHistory}
            header={<div className='tw-ts-h5'>{t(ACTIVITY_NAME_TRANSLATE[SessionActivityName.Avatar])}</div>}
        >
            <div className='vs-session-text-chat tw-mt-4 tw-pr-4 tw-h-full'>
                <div className='tw-pb-4'>
                    <DataWrapper isLoading={loading} isError={!!error}>
                        <TextChatMessageList
                            messages={messages}
                            participants={participants}
                            localParticipantId={localParticipant?.id}
                            userParticipantIds={{
                                [UserParticipantRole.Agent]: [],
                                [UserParticipantRole.Assistant]: []
                            }}
                            downloadFile={() => null}
                            messagesEndRef={null}
                            downloadingFiles={[]}
                            typingRemoteParticipantIds={[]}
                            downloadFileDisabled
                        />
                    </DataWrapper>

                </div>
            </div>
        </SidebarContent>
    );
};
